import { Api, createApi, retry } from '@reduxjs/toolkit/query/react';
import { getGqlBaseQuery, GraphqlQuery } from './helpers/graphql';
import { PENSIEVE_API_PATH } from './service-paths';

const gqlBaseQuery = getGqlBaseQuery(PENSIEVE_API_PATH);

export enum PensieveGqlApiTagTypes {
  Queue = 'queue',
  QueueAssignments = 'queue-assignments',
  QueueHistory = 'queue-history',
  QueueEarnings = 'queue-earnings',
}

export type PensieveGqlApi = Api<
  (
    { document, variables }: GraphqlQuery,
    { getState }: any
  ) => Promise<{ data: any; error?: any } | { error: { status: number; data: any }; data?: any }>,
  Record<string, any>,
  'pensieveGqlApi',
  PensieveGqlApiTagTypes
>;

export const pensieveGqlApi = createApi({
  baseQuery: retry(gqlBaseQuery, {
    maxRetries: 3,
  }) as typeof gqlBaseQuery,
  reducerPath: 'pensieveGqlApi',
  tagTypes: Object.values(PensieveGqlApiTagTypes),
  endpoints: () => ({}),
});

export const api = pensieveGqlApi;
